import script from "./context-menu-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./context-menu-settings.vue?vue&type=script&setup=true&lang=ts"

import "./context-menu-settings.vue?vue&type=style&index=0&id=0b17c557&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b17c557"]])

export default __exports__